var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBdp22 = function SvgBdp22(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 114 222"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.002,
    clipPath: "url(#bdp22_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.804 73.968C99.996 90.4 113.35 162.106 113.35 180.23c0 20.508-24.276 41.269-55.397 41.269S.653 200.738.653 180.23c0-18.089 13.302-89.563 43.376-106.17m-.026-10.732C32.36 58.308 24.21 46.731 24.21 33.246 24.209 15.16 38.869.5 56.954.5S89.7 15.16 89.7 33.246c0 13.545-8.224 25.168-19.95 30.15m0-2.64c10.36-4.826 17.54-15.328 17.54-27.51C87.29 16.49 73.71 2.91 56.954 2.91 40.2 2.91 26.62 16.49 26.62 33.246c0 12.12 7.108 22.578 17.383 27.436"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "2 1",
    d: "M69.83 80.584c25.43 16.788 36.703 80.537 36.703 96.895 0 18.887-21.34 38.007-48.695 38.007-27.357 0-50.37-19.12-50.37-38.007 0-16.339 11.245-79.96 36.615-96.837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.954 92.625a8.056 8.056 0 1 0 0-16.112 8.056 8.056 0 0 0 0 16.112Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.954 89.076a4.507 4.507 0 1 0 0-9.014 4.507 4.507 0 0 0 0 9.014Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.79 54.496h20.327c1.49 0 2.71 1.22 2.71 2.71V89.05c0 7.08-5.792 12.873-12.873 12.873S44.081 96.13 44.081 89.05V57.206c0-1.49 1.219-2.71 2.71-2.71Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bdp22_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h114v222H0z"
  })))));
};
export default SvgBdp22;